module.exports = __webpack_public_path__ + "img/check-filled.5c692c0d.svg";